import { DialogContent, Box, styled } from "@mui/material"

export const DialogContainer = styled(DialogContent)({
    padding: "8px 0px",
})

export const BoxContainer = styled(Box)({
    padding: "8px 24px",
})
